import React from 'react'
import { Box, TextBox, TextButton } from '@revolut/ui-kit'

import { useCountdown } from 'hooks/useCountdown'

const DIFFERENT_METHOD_COUNTDOWN_SECONDS = 60

type DifferentMethodProps = {
  onUseDifferentMethod: VoidFunction
}

export const DifferentMethod: React.FC<DifferentMethodProps> = ({
  onUseDifferentMethod,
}) => {
  const { timeLeft, isFinished } = useCountdown(DIFFERENT_METHOD_COUNTDOWN_SECONDS)

  return (
    <Box mt='16px'>
      {isFinished ? (
        <TextButton onClick={onUseDifferentMethod}>Use a different method</TextButton>
      ) : (
        <TextBox color='grey-50'>
          If the app is not available you can use a different method in {timeLeft}
        </TextBox>
      )}
    </Box>
  )
}
